const DEFAULT_MAX = 288;

/**
 * When GraphQL transforms (e.g. w_288_h_288) are missing, constrain Shopify CDN URLs
 * used on product/bundle tiles so we do not download full masters into small slots.
 *
 * @param {string} url
 * @param {number} [maxEdge]
 * @param {{ webp?: boolean }} [opts]
 * @returns {string}
 */
export default function shopifyCdnTileResize(
  url,
  maxEdge = DEFAULT_MAX,
  opts = {}
) {
  const { webp = false } = opts;

  if (!url || typeof url !== "string") {
    return "";
  }

  if (!/cdn\.shopify\.com/i.test(url)) {
    return url;
  }

  try {
    const u = new URL(url);
    u.searchParams.set("width", String(maxEdge));
    if (webp) {
      u.searchParams.set("format", "webp");
    }
    return u.toString();
  } catch {
    return url;
  }
}
